import React, { useContext } from 'react'
import { List } from './List'
import { Button } from './Button'
import classNames from 'classnames'
import { useTranslation } from 'utils/useTranslation'

export function ProductCardDesktop({ accessory, onClickViewDetails, isSelected, isInCart, onAddToCartClick, context }) {
  const {
    order
  } = useContext(context)

  const accessoryStrings = useTranslation('accessories_shop.misc') ?? {}
  const paymentType = order.paymentType ?? 'cash'

  return (
    <>
      <div className={classNames('mtt-product-card', { 'in-cart': isInCart })}>
        <div className='mtt-product-card__title-wrapper'>
          <div className='mtt-product-card__title'>
            <h3 className='mtt-title'>{accessory.title}</h3>
            <div className='mtt-terms'>{accessory.short_models_name.join(', ')}</div>
          </div>

          <div className='mtt-product-card__price'>
            <div className='mtt-price'>{paymentType === 'cash' ? accessory.price.formatted : accessory.price_leasing.formatted}</div>
            <div className='mtt-tagline'>{accessoryStrings.incl_vat}</div>
          </div>
        </div>

        <div className='mtt-product-card__image-wrapper'>
          <img src={accessory.image} alt='' />
        </div>

        <div className='mtt-product-card__content-wrapper'>
          <div className='mtt-product-card__content-text-wrapper'>
            <div
              className='mtt-product-card__content-text'
              dangerouslySetInnerHTML={{ __html: accessory.short_description }}
            />
          </div>

          <div className='mtt-product-card__content-list-wrapper'>
            <List items={accessory.features} />
          </div>

          <div className='mtt-product-card__content-label'>
            <div className='mtt-label' dangerouslySetInnerHTML={{ __html: accessory.obligation_text }} />
          </div>
        </div>
        <div className='button-section'>
          <Button
            classes='transparent'
            text={!isSelected ? accessoryStrings.show_details : accessoryStrings.hide_details}
            onClick={(e) => {
              e.preventDefault()
              return onClickViewDetails(!isSelected ? accessory : null)
            }}
          />
          <Button
            classes='primary'
            text={isInCart ? accessoryStrings.remove_from_cart : accessoryStrings.add_to_cart}
            onClick={onAddToCartClick}
          />
        </div>
      </div>
    </>
  )
}
